<portal-menu [portals]="displayPortals"
    [navigable]="forNavigation"
    [selectable]="forSelection"
    [selectedPortals]="selections"
    (portalExpanded)="portalExpanded($event)"
    (portalNavigated)="portalNavigated.emit()"
    (portalSelected)="portalSelected($event)"></portal-menu>